<template>
  <va-modal
    :value="showModal"
    ref="uploadLeadsStatusAMModal"
    :okToClose="false"
    :okDisabled="(form.data.gocontact && !form.data.date) || (!form.data.spice && !form.data.gocontact)"
    :okText="$t('modals.buttons.confirm')"
    :cancelText="$t('modals.buttons.cancel')"
    @ok="submit"
    @cancel="close"
  >

    <div slot="header" class="d-flex flex-column align-items-start">
      <span class="modal-title">{{ $t('leads.uploadamleads') }}</span>
    </div>

    <div class="evollu-form mb-3">
      <!-- GO CONTACT -->
      <div>
        <input id="gocontact-input" ref="gocontactInput" type="file" @change="onGoContactFileSelected" hidden accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
        <div class="d-flex w-100 justify-content-between">
          <h5>
            <b>Ficheiro Go-contact</b>
          </h5>
          <div>
            <va-popover
              v-if="!form.data.gocontact"
              placement="left"
              message="Carregar ficheiro Go-contact">
              <i class="action-icon fa fa-upload pl-2 pr-2" @click.prevent.stop="uploadGoContactFile()"></i>
            </va-popover>
          </div>
        </div>
        <div class="d-flex w-100 mb-2 mt-2">
          <div v-if="!form.data.gocontact" class="d-flex w-100 justify-content-center text-center">
            <span><b>{{$t('reports.reports.labels.no_selected_files')}}</b></span>
          </div>

          <div class="d-flex w-100" v-else>
            <div class="d-flex w-100 justify-content-between">
              <span class="filename">{{form.data.gocontact.name}}</span>
              <span>{{presentSize(form.data.gocontact.size)}}</span>
              <va-popover
                placement="left"
                :message="$t('reports.reports.buttons.delete_upload')">
                <i class="action-icon fa fa-times pl-2 pr-2" @click.prevent.stop="resetGoContactUpload()"></i>
              </va-popover>
            </div>
          </div>
        </div>
        <!-- date filter -->
        <div class="d-flex w-100 justify-content-between align-items-center mb-4">
          <span>Data do ficheiro Go-contact</span>
          <span class="gocontactDate">
            <DatePicker
              id="date-picker-range"
              v-model="form.data.date"
              placeholder=" ---" />
          </span>
        </div>
      </div>

      <!-- SPICE -->
      <input id="spice-input" ref="spiceInput" type="file" @change="onSpiceFileSelected" hidden accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
      <div class="d-flex w-100 justify-content-between">
        <h5>
          <b>Ficheiro Spice</b>
        </h5>
        <div>
          <va-popover
            v-if="!form.data.spice"
            placement="left"
            message="Carregar ficheiro Spice">
            <i class="action-icon fa fa-upload pl-2 pr-2" @click.prevent.stop="uploadSpiceFile()"></i>
          </va-popover>
        </div>
      </div>
      <div class="d-flex w-100 mb-4 mt-2">
        <div v-if="!form.data.spice" class="d-flex w-100 justify-content-center text-center">
          <span><b>{{$t('reports.reports.labels.no_selected_files')}}</b></span>
        </div>

        <div v-else class="d-flex w-100">
          <div class="d-flex w-100 justify-content-between">
            <span class="filename">{{form.data.spice.name}}</span>
            <span>{{presentSize(form.data.spice.size)}}</span>
            <va-popover
              placement="left"
              :message="$t('reports.reports.buttons.delete_upload')">
              <i class="action-icon fa fa-times pl-2 pr-2" @click.prevent.stop="resetSpiceUpload()"></i>
            </va-popover>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isSubmitingForm" class="d-flex justify-content-center">
      <hollow-dots-spinner
        :animation-duration="1000"
        :size="60"
        color="#29c4a9"
      />
    </div>


  </va-modal>
</template>
<script>
import { HollowDotsSpinner } from 'epic-spinners'
import DatePicker from '@/components/common/DatePicker'
const transitionDuration = 500

export default {
  props: {
    service: {
      type: String,
      required: true
    }
  },
  components: {
    DatePicker,
    HollowDotsSpinner
  },
  data: function () {
    return {
      showModal: false,
      isSubmitingForm: false,
      form: {
        url: `${this.service.url}/pursues-import-am`,
        method: 'POST',
        data: {
          spice: undefined,
          gocontact: undefined,
          date: this.moment().format('YYYY-MM-DD')
        },
      }
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    submit: function () {
      if (!this.isSubmitingform) {
        this.isSubmitingForm = true
        let formData = new FormData()
        if (this.form.data.gocontact) {
          formData.append('gocontact', this.form.data.gocontact)
          formData.append('date', this.form.data.date)
        }
        if (this.form.data.spice) formData.append('spice', this.form.data.spice)

        this.$http({
          url: this.form.url,
          method: this.form.method,
          data: formData
        })
          .then(response => {
            //console.log(response)
            this.showToast(this.$t('leads.am_import_success'), this.$store.state.successToastOptions)
            this.$refs.uploadLeadsStatusAMModal.cancel()
          })
          .catch(errors => {
            if (errors.response.data && errors.response.data.errors && (errors.response.data.errors.hasOwnProperty('gocontact') || errors.response.data.errors.hasOwnProperty('spice'))) {
              if (errors.response.data.errors.hasOwnProperty('gocontact')) this.showToast(this.$t('leads.gocontact_error'), this.$store.state.errorToastOptions)
              if (errors.response.data.errors.hasOwnProperty('spice')) this.showToast(this.$t('leads.spice_error'), this.$store.state.errorToastOptions)
            } else {
              this.showToast(this.$t('reports.reports.messages.something_went_wrong'), this.$store.state.errorToastOptions)
            }
            this.resetSpiceUpload()
            this.resetGoContactUpload()
          })
          .finally(() => {
            this.isSubmitingForm = false
            this.$emit('amexcelUpload', null)
          })
      }
    },
    close: function () {
      setTimeout(() => {
        this.$emit('modalWasClosed')
      }, transitionDuration)
    },
    uploadSpiceFile: function () {
      this.$refs.spiceInput.click()
    },
    onSpiceFileSelected: function (event) {
      this.form.data.spice = event.target.files[0]
    },
    resetSpiceUpload: function () {
      this.form.data.spice = undefined
      this.$refs.spiceInput.value = null
    },
    uploadGoContactFile: function () {
      this.$refs.gocontactInput.click()
    },
    onGoContactFileSelected: function (event) {
      this.form.data.gocontact = event.target.files[0]
    },
    resetGoContactUpload: function () {
      this.form.data.gocontact = undefined
      this.$refs.gocontactInput.value = null
    },
    presentSize: function (bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return '0 Byte'
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    }
  }
}
</script>
<style scoped lang="scss">
.filename {
  width: 60%;
}

.gocontactDate input {
  min-height: 35px;
  padding-left: 0.5rem;
  border: 1px solid #e8e8e8;
  background-color: #ffffff !important;
  border-radius: .4rem;
  outline: none;
}

.action-icon {
  cursor: pointer;
}

</style>
